import React, { useState, useEffect, createContext, useContext } from 'react';
import { useStyle } from './Style.tsx';

export function PreviewFrame({ children }) {
    return <>{children}</>
}